// export const STEP_REQUEST_DETAIL = "request detail";
// export const STEP_REVIEW_REQUEST = "review request";
// export const STEP_DISSOLUTION = "dissolution";
// export const STEP_FORMATION = "formation";
// export const STEP_SALE = "sale";
// export const STEP_CONCURRENCE = "concurrence";
// export const STEP_MERGER = "merger";
// export const STEP_OTHER = "other";
// export const GENERAL_DETAILS = "General Details";
// export const PROPOSAL_DETAILS = "Proposal Details";
// export const ASSIGNMENTS = "Assignments";
// export const REVIEW = "Review";
// export const SUBMIT = "Submit";
// export const REQUEST_ID = "";
// export const ACQUISITION_PROPOSAL = "Acquisition";
// export const PROPOSAL_ID = "";

import { c } from "@angular/core/navigation_types.d-u4EOrrdZ";
import { NextPageRoute } from "@cvx/nextpage";
import { HomeComponent } from "../pages/home/home.component";
import { CalGuardService, } from '@cvx/cal-angular';



//Grid Constant
export const PAGE_INDEX=1;
export const PAGE_SIZE=6;
export const NO_RESULT="Not Record Found";
export const OTHERS="Other";
export const SUCCESS="Success";
export const ServiceNowURL="https://chevrontest.service-now.com/now/nav/ui/classic/params/target/sc_req_item.do%3Fsys_id%3D";

export enum OthersType {
    Country= "country",
    Skills = "skills",
    PracticeArea = "practiceArea",
    Notary = "notary",
    Institution = "institution",
    University = "university",
    Degree = "degree",
    Language = "language",
  }

export enum Role{
   User="User",
   Admin="Admin"
}

export enum Menu{
  requestacess="request access",
  myrequestsdashboard="my requests dashboard",
  myapprovalsdashboard="my approvals dashboard",
  admin="admin",
  faq="faqs",
  orgchart='orgchart'
}

export enum DateFormat{
  yyyyddmm="yyyy-MM-dd",
  mmddyyyy="MM/dd/yyyy"
}
export class Constants {
  public static readonly STEP_REQUEST_DETAIL = "request detail";
  public static readonly STEP_REVIEW_REQUEST = "review request";
  public static readonly STEP_DISSOLUTION = "dissolution";
  public static readonly STEP_FORMATION = "formation";
  public static readonly STEP_SALE = "sale";
  public static readonly STEP_CONCURRENCE = "concurrence";
  public static readonly STEP_MERGER = "merger";
  public static readonly STEP_OTHER = "other";
  public static readonly GENERAL_DETAILS = "General Details";
  public static readonly PROPOSAL_DETAILS = "Proposal Details";
  public static readonly ASSIGNMENTS = "Assignments";
  public static readonly REVIEW = "Review";
  public static readonly SUBMIT = "Submit";
  public static readonly REQUEST_ID = "";
  public static readonly ACQUISITION_PROPOSAL = "Acquisition";
  public static readonly PROPOSAL_ID = "";
  public static readonly USER_INFO_RESOLVER_KEY = "user_info_key";

  public static readonly PHOTO_TOKEN_KEY="photoToken";
  public static readonly TOKEN_KEY="token";
  public static readonly TOKEN_EXPIRATION_KEY="token_expiration";
  public static readonly SHOW_MESSAGE_DURATION = 5000;
  public static readonly SHOW_MESSAGE_DURATION_FOR_ERROR = 10000;
  public static readonly SKIP_LOADER_HEADER_KEY = 'Skip-Loader';
  public static readonly ALL_BLOCK_CODE = 3;
  
}

export class ErrorCode {
  public static readonly SERVER_ERROR = "500";
  public static readonly SERVER_NOT_AVAILABLE = "Unknown Error";
}

export class NavigationConstants { 
  public static readonly adminRoutes: NextPageRoute[] = [
    {
      path: 'admin',
      title: 'Adminstration',
      children: [
        {
          title: 'User Details', path: 'user_details', component: HomeComponent,canActivate: [CalGuardService]
        },
        {
          title: 'Departments', path: 'departments', component: HomeComponent,canActivate: [CalGuardService]
        },
        {
          title: 'Sub Departments', path: 'sub_departments', component: HomeComponent,canActivate: [CalGuardService]
        },
        {
          title: 'Company', path: 'company', component: HomeComponent,canActivate: [CalGuardService]
        },
        {
          title: 'Dep Rep/JV Advisor Mapping', path: 'dep_jv', component: HomeComponent,canActivate: [CalGuardService]
        },
        {
          title: 'Holiday', path: 'holiday', component: HomeComponent,canActivate: [CalGuardService]
        }
      ],
    }];
  
    public static readonly saasAndHelpRoutes: NextPageRoute[] = [
      {
        path: 'sasbu',
        title: 'SASBU Home Page',
        component: HomeComponent,
        canActivate: [CalGuardService]
      },
      {
        path: 'help',
        title: 'Help',
        component: HomeComponent,
        canActivate: [CalGuardService]
      }];
}
